// ─── src/data/vendors.js ──────────────────────────────────────────────────────
import { hydrateScores } from "../engine/index.js";

export const VENDORS = []; // fake demo data removed, real listings only

export const VENDOR_CATEGORIES = [
  "All", "planner", "photographer", "videographer", "florist", "caterer", "musician", "celebrant",
];

export const PLANNER_SERVICE_TIERS = [
  "Full Planning",
  "Partial Planning",
  "Day Coordination",
  "Design and Styling",
];

// ── Hydrate curated index scores ─────────────────────────────────────────────
hydrateScores(VENDORS);
